module.exports = __webpack_public_path__ + "static/img/municipalidades.a2a813ac.png";